// extracted by mini-css-extract-plugin
module.exports = {"popup":"AnketaFormPopup_popup__1pse5","popupWithBigIcon":"AnketaFormPopup_popupWithBigIcon__lfT_s","popupSubtitleContainer":"AnketaFormPopup_popupSubtitleContainer__lBqh7"};